import { Polygon, PolygonShape } from "../display/Polygon.js";
import { Stage } from "../display/Stage.js";

export interface ShapeAppOptions {
    element: HTMLDivElement;
}

export class ShapeApp {

    private _element: HTMLDivElement;
    private _stage: Stage;
    private _options: ShapeAppOptions;

    constructor(options: ShapeAppOptions) {

        this._options = options;
        this._element = options.element;

        this.init();
    }

    private async init() {
        this._stage = new Stage({
            element: this._element,
            className: "shape-app",
            layout: "responsive"
        });

        try {
            let list = document.createElement("div");
            list.className = "shape-app__list";

            let center = document.createElement("div");
            center.className = "shape-app__list-center";
            list.appendChild(center);

            for (let i = 1; i <= Polygon.TOTAL_SHAPES; ++i) {

                let item = document.createElement("div");
                item.className = "shape-app__list-item";
                center.appendChild(item);

                new Polygon({
                    shape: String(i) as PolygonShape,
                    container: item
                });

                let info = document.createElement("div");
                info.className = "shape-app__list-item-info";
                info.textContent = i + "";
                item.appendChild(info);
            }
            this._stage.content.appendChild(list);

        } catch (error) {
            var err = error as Error;
            console.error(error);
            this._stage.preloader.showError(err?.message || "Es ist ein Unbekannter Fehler aufgetreten.");
            return;
        }

        this._stage.preloader.hide();
    }
}